import './PreventiveFiltersFooter.scss';

import { useApplyFilters } from "../../../../../hooks/useApplyFilters";

import { Button } from "../../../../../common-components/Buttons/Buttons";

const PreventiveFiltersFooter = () => {
    const componentId = "preventive";
    const { applyFiltersParams } = useApplyFilters({componentId})

    return (
        <div className={"preventive-filters-footer"}>
            <div className={"preventive-filters-footer_container"}>
                <div className={"preventive-filters-footer_buttons"}>
                    <Button title={"Применить"} onClick={applyFiltersParams}/>
                </div>
            </div>
        </div>
    )
}

export default PreventiveFiltersFooter;